import React, { useEffect } from 'react'

import { SurveyTemplates } from '../../../api/services/user_assignment_codes/types.ts'
import { useSurveys } from '../../../hooks/useSurveys.ts'
import Card from '../../common/Card/Card.tsx'
import Loader from '../../common/Loader/Loader.tsx'
import SurveyTable from '../SurveyTable'

const SurveyAssignment = ({
  mainCodeId,
  codeAssignmentID,
  codeAssignment,
  surveyTemplates
}: {
  mainCodeId: number
  codeAssignmentID: number
  codeAssignment: string
  surveyTemplates: SurveyTemplates[]
}) => {
  const { surveys, fetchSurveys, loading } = useSurveys()

  useEffect(() => {
    fetchSurveys()
  }, [])

  return (
    <div>
      <div className="mx-auto mt-11">
        <Card>
          <Card.Title>Lista dostępnych ankiet</Card.Title>
          <Card.Body>
            {loading && <Loader label={'Pobieranie danych...'} />}
            <div className="flex flex-col gap-2 mb-5">
              {surveys && (
                <SurveyTable
                  mainCodeId={mainCodeId}
                  surveys={surveys}
                  codeAssignmentID={codeAssignmentID}
                  codeAssignment={codeAssignment}
                  surveyTemplates={surveyTemplates}
                />
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}

export default SurveyAssignment
